<ion-header [translucent]="true" >
  <ion-toolbar>
    <ion-buttons slot="start">
      @if (!isModal) {
        <ion-button [routerLink]="['/inventory/taps']">
          <ion-icon name="arrow-back-outline" slot="icon-only"></ion-icon>
        </ion-button>
      }
    </ion-buttons>
    <ion-buttons slot="end">
      @if (isModal) {
        <ion-button (click)="closeModal()"> Close</ion-button>
      }
      @if (!isModal) {
        <ion-button (click)="confirmAlert(itemWithKeg()!)" data-testid="tap-detail-delete">
          <ion-icon
            slot="icon-only"
            color="danger"
            name="trash-outline"
          ></ion-icon>
        </ion-button>
        <ion-button (click)="openHelpModal()">
          <ion-icon slot="icon-only" name="help-circle-outline"></ion-icon>
        </ion-button>
	 }
    </ion-buttons>
    <ion-title>
      <span>{{ itemWithKeg()?.name }}</span>
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <app-form
    [useWashing]="bar()?.useWashing ?? false"
    [uid]="user()?.uid ?? ''"
    [item]="itemWithKeg()!"
    [allTaps]="allTaps()"
    [allKegs]="allKegs()"
    [allPlaato2s]="allPlaato2s()"
    [allKegtrons]="allKegtrons()"
    [allCustomKegMons]="allCustomKegMons()"
    (softUpdateKeg)="softUpdateKeg($event)"
    (softUpdateTap)="softUpdateTap($event)"
  ></app-form>

  <app-tap-stats
    [items]="statistics()!"
    [units]="units()!"
  ></app-tap-stats>
</ion-content>
